import { lazy } from 'react';

export const FieldRoutes = lazy(() =>
  import('@/field/FieldRoutes').then((module) => ({ default: module.FieldRoutes })),
);
